import styled from "styled-components";
import { IThemeProvider } from "../../../../Theme/defaultTheme";
import { BasicContentParagraph } from "../../../../Theme/basicElements";

export const AuthFormContainer = styled.div<IThemeProvider>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 576px;
  padding: 68px 80px;
  box-sizing: border-box;
  border-radius: ${props => props.theme.format.main_lg_border_radius};
  background-color: ${props => props.theme.colors.white};
`;

export const AuthSelector = styled.div`
  display: flex;
  gap: 8px;
  width: max-content;
  margin-bottom: 64px;
`;

export const AuthSelectorButton = styled.button<IThemeProvider>`
  font-family: ${props => props.theme.font_style.font_family};
  font-weight: ${props => props.theme.font_style.font_weight.regular};
  font-size: ${props => props.theme.font_sizes.content};
  color: ${props => props.theme.colors.black};
  border: 0;

  background-color: transparent;
  border-radius: ${props => props.theme.format.main_md_border_radius};
  padding: ${props => props.theme.format.main_md_padding} ${props => props.theme.format.main_lg_padding};
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.primary_purple};
  }

  &:focus-visible {
    background-color: ${props => props.theme.colors.primary_purple};
    outline: 0;
  }

  &:disabled {
    outline: 1px solid ${props => props.theme.colors.secondary_btn};
    cursor: auto;
    background-color: transparent;
  }
`;

export const StyledForm = styled.form`
  display: flex;
  width: 100%;
  flex-direction: column;

  position: relative;
`;

export const AuthInputsBlock = styled.div<IThemeProvider>`
  display: flex;
  flex-direction: column;
  width: 100%;

  margin-bottom: 48px;
`;

export const AuthInputs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  gap: 32px;
`;

export const AuthSubmitBlock = styled.div<IThemeProvider>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: ${props => props.theme.format.main_sm_gap};
`;

export const AuthSubmitPrivacy = styled(BasicContentParagraph)<IThemeProvider>`
  font-size: ${props => props.theme.font_sizes.small};

  & a {
    color: ${props => props.theme.colors.brand_blue};
    text-decoration: none;
    cursor: pointer;

    &:hover {
      color: ${props => props.theme.colors.brand_orange};
      text-decoration: underline;
    }
  }
`;

export const AuthButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 32px;
`;

export const AuthInputErrorText = styled.span<IThemeProvider>`
  display: none;
  position: absolute;
  width: max-content;

  bottom: -24px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;

  font-family: ${props => props.theme.font_style.font_family};
  font-weight: ${props => props.theme.font_style.font_weight.regular};
  font-size: ${props => props.theme.font_sizes.small};

  color: ${props => props.theme.colors.secondary_red};

  &[data-in-error='true'] {
    display: block;
  }
`;

export const AuthFormErrorText = styled(AuthInputErrorText)`
  bottom: 32px;
`;

export const ForgotSpan = styled.span<IThemeProvider>`
  display: block;
  width: max-content;
  font-family: ${props => props.theme.font_style.font_family};
  font-size: ${props => props.theme.font_sizes.small};
  font-weight: ${props => props.theme.font_style.font_weight.regular};
  align-self: end;
  cursor: pointer;
  margin-top: 16px;

  & a {
    color: ${props => props.theme.colors.brand_blue};
    text-decoration: none;

    &:hover {
      color: ${props => props.theme.colors.brand_orange};
      text-decoration: underline;
    }
  }
`;